import { render, staticRenderFns } from "./WorkNotificationMenu.vue?vue&type=template&id=d6849182&scoped=true"
import script from "./WorkNotificationMenu.vue?vue&type=script&lang=js"
export * from "./WorkNotificationMenu.vue?vue&type=script&lang=js"
import style0 from "./WorkNotificationMenu.vue?vue&type=style&index=0&id=d6849182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6849182",
  null
  
)

export default component.exports